import { Avatar } from '@/components/tree/Avatar'
import { Select, SelectContent, SelectItem, SelectSeparator, SelectTrigger, SelectValue } from '@/components/ui/select'

// The design library's select can't hold an empty value, so "no one" travels under this name inside it.
const NONE = 'none'

// Picking someone from the tree, each with their face. With `none`, there's a first choice for no one at all.
export function PersonSelect({
  id,
  people,
  value,
  onChange,
  placeholder,
  none,
  'aria-label': label,
  className,
}: {
  id?: string
  people: { id: string; name: string; portrait?: string | null; living?: boolean }[]
  value: string
  onChange: (id: string) => void
  placeholder: string
  none?: string
  'aria-label'?: string
  className?: string
}) {
  return (
    <Select value={value} onValueChange={(v) => onChange(v === NONE ? '' : v)}>
      <SelectTrigger id={id} aria-label={label} className={className}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {none && (
          <>
            <SelectItem value={NONE} className="text-muted-foreground">
              {none}
            </SelectItem>
            <SelectSeparator />
          </>
        )}
        {people.map((p) => (
          <SelectItem key={p.id} value={p.id}>
            <span className="flex min-w-0 items-center gap-2.5">
              <Avatar person={{ ...p, portrait: p.portrait ?? null }} className="size-7 text-xs shadow-none" />
              <span className="truncate">
                {p.name}
                {p.living === false && <span className="text-muted-foreground"> (in memory)</span>}
              </span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
